import React from 'react';
import Reference1 from 'assets/png/reference_1.png';
import Reference2 from 'assets/png/reference_2.png';
import Reference3 from 'assets/png/reference_3.png';
import Reference4 from 'assets/png/reference_4.png';
import Reference5 from 'assets/png/reference_5.png';
import Reference6 from 'assets/png/reference_6.png';
import Reference7 from 'assets/png/reference_7.png';
import Reference8 from 'assets/png/reference_8.png';
import Reference9 from 'assets/png/reference_9.png';
import Reference10 from 'assets/png/reference_10.png';
import Reference11 from 'assets/png/reference_11.png';
import './index.css';

function Reference() {
    return (
        <div className='digitalReference'>
            <div className='digitalReference__figures'>
                <div className='digitalReference__figureGroup'>
                    <div className='digitalReference__figureGroupFigures'>
                        <img className='digitalReference__figure' src={Reference1} />
                        <img className='digitalReference__figure' src={Reference2} />
                    </div>
                </div>
                <div className='digitalReference__figureGroup'>
                    <div className='digitalReference__figureGroupFigures'>
                        <img className='digitalReference__figure' src={Reference3} />
                        <img className='digitalReference__figure' src={Reference4} />
                    </div>
                </div>
                <div className='digitalReference__figureGroup'>
                    <div className='digitalReference__figureGroupFigures'>
                        <img className='digitalReference__figure' src={Reference5} />
                        <img className='digitalReference__figure' src={Reference6} />
                    </div>
                    <p className='digitalReference__figureText'>
                        Special Right Triangles
                    </p>
                </div>
                <div className='digitalReference__figureGroup'>
                    <div className='digitalReference__figureGroupFigures'>
                        <img className='digitalReference__figure' src={Reference7} />
                        <img className='digitalReference__figure' src={Reference8} />
                    </div>
                </div>
                <div className='digitalReference__figureGroup'>
                    <div className='digitalReference__figureGroupFigures'>
                        <img className='digitalReference__figure' src={Reference9} />
                        <img className='digitalReference__figure' src={Reference10} />
                    </div>
                </div>
                <div className='digitalReference__figureGroup'>
                    <div className='digitalReference__figureGroupFigures'>
                        <img className='digitalReference__figure' src={Reference11} />
                    </div>
                </div>
            </div>
            <p className='digitalReference__text'>
                The number of degrees of arc in a circle is 360.
            </p>
            <p className='digitalReference__text'>
                The number of radians of arc in a circle is 2&pi;.
            </p>
            <p className='digitalReference__text'>
                The sum of the measures in degrees of the angles of a triangle is 180.
            </p>
        </div>
    );
}

export default Reference;